import React from 'react'
import * as RT from '../../constants/Routing'
import * as SG from '../../constants/AppSettings'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Modal from '../App/Modal'
import { withRouter } from 'react-router-dom'
import * as Actions from '../../actions/Community'
// import defaultPhoto from '../../lib/images/default-back.jpg'
import defaultUserPhoto from '../../lib/images/user-thumb-default.png'
import CommunityHeader from './CommunityHead'

class Component extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false
    }
  }

  openModal = () => {
    this.setState({
      openModal: true
    })
  }

  closeModal = () => {
    this.setState({
      openModal: false
    })
  }

  nl2br = (text) => {
    if (!!text) {
      var regex = /(\r\n|\n|\r)/gm
      return text.split(regex).map(function (line) {
        if (line.match(regex)) {
          return React.createElement('br')
        }
        else {
          return line;
        }
      });
    }
  }

  publishCommunity = (id, approval) => {
    this.closeModal()
    this.props.communityPublish(id,approval)
  }

  updateCommunity = (id) => {
    let selectedCommunity
    if (!!this.props.preview) {
      selectedCommunity = this.props.Community.previewCommunity
    } else {
      selectedCommunity = this.props.Community.community
    }

    this.closeModal()
    this.props.communityUpdate(this.props.Community.updateFormData, id, !!this.props.preview)
  }

  componentWillUnmount = () => {
    this.closeModal()
  }

  componentWillMount = () => {
    const preview = !!this.props.preview
    const communityId = this.props.match.params.id
    if (preview) {
      if (!this.props.Community.previewCommunity) {
        this.props.communityGet(communityId, true)
      } else {

      }
    } else {
      if (!this.props.Community.community) {
        this.props.communityGet(communityId, false)
      }
    }
  }

  componentWillUpdate = () => {
    if (this.props.Community.joined) {
      this.props.communityJoinReset()
      this.setState({ openModal: false })
    }
  }


  parseDescription = (desc) => {
    if (!!desc) {
      let title1, title1_reg, title2, title2_reg, title3, title3_reg, body1, body1_reg, body2, body2_reg, body3, body3_reg, reg

      reg = new RegExp(SG.COMMUNITY_TITLE1_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_TITLE1_MARK_REG)
      title1_reg = desc.match(reg)
      title1 = !!title1_reg ? title1_reg[0].replace(SG.COMMUNITY_TITLE1_MARK, '').replace(SG.COMMUNITY_TITLE1_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_TITLE2_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_TITLE2_MARK_REG)
      title2_reg = desc.match(reg)
      title2 = !!title2_reg ? title2_reg[0].replace(SG.COMMUNITY_TITLE2_MARK, '').replace(SG.COMMUNITY_TITLE2_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_TITLE3_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_TITLE3_MARK_REG)
      title3_reg = desc.match(reg)
      title3 = !!title3_reg ? title3_reg[0].replace(SG.COMMUNITY_TITLE3_MARK, '').replace(SG.COMMUNITY_TITLE3_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_BODY1_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_BODY1_MARK_REG)
      body1_reg = desc.match(reg)
      body1 = !!body1_reg ? body1_reg[0].replace(SG.COMMUNITY_BODY1_MARK, '').replace(SG.COMMUNITY_BODY1_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_BODY2_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_BODY2_MARK_REG)
      body2_reg = desc.match(reg)
      body2 = !!body2_reg ? body2_reg[0].replace(SG.COMMUNITY_BODY2_MARK, '').replace(SG.COMMUNITY_BODY2_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_BODY3_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_BODY3_MARK_REG)
      body3_reg = desc.match(reg)
      body3 = !!body3_reg ? body3_reg[0].replace(SG.COMMUNITY_BODY3_MARK, '').replace(SG.COMMUNITY_BODY3_MARK, '') : ''

      const reg_descriptions = {
        title1: title1 || "",
        title2: title2 || "",
        title3: title3 || "",
        body1: body1 || "",
        body2: body2 || "",
        body3: body3 || ""
      }
      return reg_descriptions
    } else {
      return {
        title1: "",
        title2: "",
        title3: "",
        body1: "",
        body2: "",
        body3: ""
      }
    }
  }

  render = () => {
    const currentUser = this.props.currentUser
    let selectedCommunity
    const currentPath = this.props.currentPath
    const preview = !!this.props.preview


    let published, description, title1, title2, title3, body1, body2, body3, descriptionParsed, host, membersList, id, bottomBtn, previewHead, modal, statusHeader, approval

    if (preview) {
      selectedCommunity = this.props.Community.previewCommunity
    } else {
      selectedCommunity = this.props.Community.community
    }

    if (!!selectedCommunity) {
      id = selectedCommunity.id || ""
      approval = selectedCommunity.approval

      // category = selectedCommunity.category || "<未入力(カテゴリ)>"
      if (preview) {
        description = selectedCommunity.description || ""
        descriptionParsed = this.parseDescription(description)
        title1 = descriptionParsed.title1 || '<未入力(タイトル1)>'
        title2 = descriptionParsed.title2 || '<未入力(タイトル2)>'
        title3 = descriptionParsed.title3 || '<未入力(タイトル3)>'
        body1 = descriptionParsed.body1 || '<未入力(本文1)>'
        body2 = descriptionParsed.body2 || '<未入力(本文2)>'
        body3 = descriptionParsed.body3 || '<未入力(本文3)>'
      } else {
        description = selectedCommunity.description || ""
        descriptionParsed = this.parseDescription(description)
        title1 = descriptionParsed.title1 || ''
        title2 = descriptionParsed.title2 || ''
        title3 = descriptionParsed.title3 || ''
        body1 = descriptionParsed.body1 || ''
        body2 = descriptionParsed.body2 || ''
        body3 = descriptionParsed.body3 || ''
      }


      published = selectedCommunity.published

      membersList = selectedCommunity.members.map((user) => {
        const photo = user.photo || defaultUserPhoto
        return (
          <div className='col-6'>
            <Link to={RT.USER_SHOW_PATH.replace(/:id/, user.id)}>
              <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
            </Link>
            <span>{user.name}</span>
          </div>
        )
      })

      host = !!selectedCommunity.host ? selectedCommunity.host : currentUser

      if (preview) {
        // プレビューの場合

        previewHead = (
          <div className='preview-head-box'>
            <p className='info-text'>※このページはプレビューです</p>
          </div>
        )

        if (!published) {
          // 公開済みでない場合
          modal = (
            <Modal
              okClickHandler={() => this.publishCommunity(id, approval)}
              headerTitle='サークルを公開します。'
              isOpen={this.state.openModal}
              closeModal={this.closeModal}
              okText='公開する'
            >
              <p>この内容で本当に公開してよろしいですか？</p>
            </Modal>
          )

          bottomBtn = (
            <div className='preview-bottom-box'>
              <div className='container'>
                <div className='row'>
                  <div className='col-6'>
                    {/* <Link to={RT.COMMUNITY_EDIT_PATH.replace(/:id/, id)} className='btn btn-white'>戻る</Link> */}
                    <span className='btn btn-white' onClick={this.props.backToForm}>
                      戻る
                    </span>
                  </div>
                  <div className='col-6'>
                    <span className='btn btn-submit'
                    onClick={this.openModal}
                    >公開する</span>
                  </div>
                </div>
              </div>
            </div>
          )
        } else {
          modal = (
            <Modal
              okClickHandler={() => this.updateCommunity(id)}
              headerTitle='サークルを更新します。'
              isOpen={this.state.openModal}
              closeModal={this.closeModal}
              okText='更新する'
            >
              <p>この内容で本当に更新してよろしいですか？</p>
            </Modal>
          )

          bottomBtn = (
            <div className='preview-bottom-box'>
              <div className='container'>
                <div className='row'>
                  <div className='col-6'>
                    {/* <Link to={RT.COMMUNITY_EDIT_PATH.replace(/:id/, id)} className='btn btn-white'>戻る</Link> */}
                    <span className='btn btn-white' onClick={this.props.backToForm}>
                      戻る
                    </span>
                  </div>
                  <div className='col-6'>
                    <span className='btn btn-submit' onClick={this.openModal}>更新する</span>
                  </div>
                </div>
              </div>
            </div>
          )
        }

      } else {
        // プレビューじゃないとき
        
        if (!published) {
          // 非公開時
          statusHeader = (
            <div className='preview-head-box'>
              <p className='info-text'>※このページは公開されていません</p>
            </div>
          )
        }
      
      }

    }

    return (
      <section className='circleShow'>
        {(() => {
          if (preview) {
            return (
              ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))
            )
          }
        })()}
        {previewHead}
        {statusHeader}
        <CommunityHeader currentUser={currentUser} currentPath={currentPath} circle={selectedCommunity} preview={preview} openModal={this.openModal} />

        <div className='pc-container'>
          <div className='row'>
            <div className='circleBody col-12 col-md-8 col-lg-9 mb20'>
              <h2 className='headline'>{title1}</h2>
              <p>{this.nl2br(body1)}</p>

              {(() => {
                if ((title2 && body2) || preview) {
                  return (
                    <div>
                      <h2 className='headline'>{title2}</h2>
                      <p>{this.nl2br(body2)}</p>
                    </div>
                  )
                }
              })()}
              {(() => {
                if ((title3 && body3) || preview) {
                  return (
                    <div>
                      <h2 className='headline'>{title3}</h2>
                      <p>{this.nl2br(body3)}</p>
                    </div>
                  )
                }
              })()}
            </div>

            {(() => {
              if (!!host) {
                return (
                  <div className='sideBody col-12 col-md-4 col-lg-3'>
                    <Link to={RT.USER_SHOW_PATH.replace(/:id/, host.id)}>
                      <h3 className='headline'>メンバー</h3>
                      <div className='host-info'>
                        <p>管理人</p>
                        <div className='userThumb host' style={{ backgroundImage: `url(${host.photo ? host.photo : defaultUserPhoto})` }}></div>
                        <p>{host.name}</p>
                      </div>
                      <div className='row'>
                        {membersList}
                      </div>
                    </Link>
                  </div>
                )
              }
            })()}
          </div>
        </div>
        {ReactDOM.createPortal(bottomBtn, document.getElementById('fixedBottomWrap'))}
      </section>
    )
  }

}



const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch))


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component)

export default withRouter(Container)


// WEBPACK FOOTER //
// ./src/components/Community/Detail.jsx